import axiosHttp from "services/axiosHttp";
import { USER } from "constants/AuthConstant";
import PermissionManager from "utils/class/PermissionManager";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchPaymentMethods = createAsyncThunk("fetchPaymentMethods", async () => {
	const user = PermissionManager.getItem(USER)?.user;
	const channel_id = user?.user_channel?.[0]?.channel_uuid;
	if (!channel_id) throw new Error("Channel ID not found");
	const response = await axiosHttp.get(`channel/${channel_id}/payment/request/paymentMethods`);
	return response.data.data;
});

const PaymentMethodsSlice = createSlice({
	name: "PaymentMethodsSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchPaymentMethods.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchPaymentMethods.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchPaymentMethods.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default PaymentMethodsSlice.reducer;
